import {SearchTypes} from "../../types/common/search.types";
import apiClient from "../apiClient";
import {ResponseDto} from "../ResponseDto";
import {PageTypes} from "../../types/page.types";
import {WithdrawalInfoTypes, WithdrawalSettingType, WithdrawalTypes} from "../../types/settlement/settlement.types";


export const getMemberWithdrawalList = (searchData : SearchTypes) =>
    apiClient.get<ResponseDto<PageTypes>>("/api/front/withdrawal/getMemberWithdrawalList",
        {
            params: searchData,
            headers: {'Content-Type': 'application/json'}
        }
    );


export const getWithdrawalFeeInfo = () =>
    apiClient.get<ResponseDto<WithdrawalSettingType>>("/api/front/withdrawal/getWithdrawalFeeInfo");


export const memberWithdrawalRequest = (withdrawalType: WithdrawalTypes) =>
    apiClient.post<ResponseDto<any>>("/api/front/withdrawal/memberWithdrawalRequest",
        withdrawalType);


export const getMemberWithdrawalDetail = (withdrawalCode : string) =>
    apiClient.get<ResponseDto<WithdrawalInfoTypes>>("/api/front/withdrawal/getMemberWithdrawalDetail",
        {
            params: {withdrawalCode},
            headers: {'Content-Type': 'application/json'}
        }
    );